import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:3000/dev/',
  headers: {
    'x-api-key': process.env.REACT_APP_BASE_URL_SECRET || 'd41d8cd98f00b204e9800998ecf8427e',
  },
});